import { Component, effect, inject, OnDestroy, OnInit } from "@angular/core";
import { ActivatedRoute, Params, Router } from "@angular/router";
import { SharedMessageRepositoryTable } from "../../repositories/shared-message-repository-table";
import { NavigationService } from "../../helper/navigation-service";
import dayjs from "dayjs";
import { MessagePreview, MessageDetails, MessageDraft } from "../../models/message";
import { Observable, Subject } from "rxjs";
import { NgClass } from "@angular/common";
import { ScreenStore, UserStore } from "../../stores/index";
import { CellClickedEvent } from "ag-grid-community";
import { JhmTableComponent } from "../jhm-table/jhm-table.component";

@Component({
	selector: "jhm-message-detail",
	templateUrl: "./message-detail.component.html",
	styleUrls: ["./message-detail.component.scss"],
	imports: [NgClass, JhmTableComponent]
})
export class MessageDetailComponent implements OnDestroy, OnInit
{
	public messageDetails: MessageDetails;
	public selectedPage: string = "MESSAGE";
	public messageRepository: SharedMessageRepositoryTable;
	public userType: string;
	public screenSize: string;
	public isMobile: boolean = false;
	private activatedRoute: ActivatedRoute;
	private navigationService: NavigationService;
	private router: Router;
	public ngDestroyed$: Subject<any> = new Subject();

	readonly screenStore = inject(ScreenStore);
	readonly userStore = inject(UserStore);

	public constructor(activatedRoute: ActivatedRoute, messageRepository: SharedMessageRepositoryTable,
		navigationService: NavigationService, router: Router)
	{
		this.activatedRoute = activatedRoute;
		this.messageRepository = messageRepository;
		this.navigationService = navigationService;
		this.router = router;

		effect(() => {
			this.userType = this.userStore.type();
		})

		effect(() => {
			this.screenSize = this.screenStore.screenSize();
			if (this.screenSize === "MOBILE") {
				this.isMobile = true;
			}
			else {
				this.isMobile = false;
			}
		})
	}

	public ngOnInit(): void
	{
		this.activatedRoute.params.subscribe((params: Params) =>
		{
			this.messageRepository.getMessageDetails(params.id).subscribe((messageDetails: MessageDetails) =>
			{
				this.messageDetails = messageDetails;
			});
		});
	}

	ngOnDestroy(): void
	{
		this.ngDestroyed$.next(true);
	}

	public switchPage(newPage: string): void
	{
		this.selectedPage = newPage;
	}

	public goToPreviousPage(): void
	{
		this.navigationService.goToPreviousPage("/");
	}

	public getTimeString(): string
	{
		return dayjs.unix(this.messageDetails.sentSecondsFromEpoch).format("dddd, MMM D, YYYY | h:mm");
	}

	public cellClicked(click: CellClickedEvent) {
		this.messageClicked(click.data);
	}

	public messageClicked(message: MessagePreview): void
	{
		this.router.navigate(["/messages/" + message.id]);
	}

	public reply(): void
	{
		this.messageRepository.createMessageDraft(this.messageDetails.senderId).subscribe((draftSub: Observable<MessageDraft>) =>
		{
			draftSub.subscribe(
				(messageDraft: MessageDraft) =>
				{
					this.router.navigate(["drafts/messages/" + messageDraft.id]);
				});
		});
	}

	public delete(): void
	{
		this.messageRepository.deleteIncomingMessage(this.messageDetails.id).subscribe(() =>
		{
			this.goToPreviousPage();
		});
	}
}
